import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import DashboardLayout from '../../components/Layout/DashboardLayout';
import InfoCard from '../../components/ui/InfoCard'; // Import the new InfoCard component

// Placeholder images - import or use URLs as needed
const placeholderImgUrl = 'https://placehold.co/600x400/EFEFEF/AAAAAA&text=Placeholder';
const serviceImage1Url = 'https://placehold.co/400x300/e0e0e0/999999&text=service+image+2';
const serviceImage2Url = 'https://placehold.co/400x300/e0e0e0/999999&text=service+image+2';
const serviceImage3Url = 'https://placehold.co/400x300/e0e0e0/999999&text=service+image+2';
const serviceImage4Url = 'https://placehold.co/400x300/e0e0e0/999999&text=service+image+2';
const serviceImage5Url = 'https://placehold.co/400x300/e0e0e0/999999&text=service+image+2';
const serviceImage6Url = 'https://placehold.co/400x300/e0e0e0/999999&text=service+image+2';

// Placeholder data - in a real app, this would come from props or an API based on the itineraryId
const galleryData = {
    categories: [
        { id: 'alojamiento', title: 'Alojamiento', image: placeholderImgUrl },
        { id: 'alimentacion', title: 'Alimentación', image: placeholderImgUrl },
        { id: 'transporte', title: 'Transporte', image: placeholderImgUrl },
        { id: 'actividades', title: 'Actividades', image: placeholderImgUrl },
    ],
    services: [
        {
            id: 'habitacion',
            category: 'alojamiento',
            title: 'Habitación',
            images: [
                [serviceImage1Url, serviceImage2Url, serviceImage3Url], // First slide
                [serviceImage4Url, serviceImage5Url, serviceImage6Url]  // Second slide
            ]
        },
        // Add more services for other categories as needed
    ]
};

const ItineraryGalleryUserScreen = () => {
    const { id: itineraryId } = useParams(); // Get itinerary ID from URL

    // Filter services for a specific category, e.g., "Alojamiento"
    // In a real app, you might have a more dynamic way to select/show categories
    const currentCategory = galleryData.categories.find(cat => cat.id === 'alojamiento');
    const servicesForCurrentCategory = galleryData.services.filter(
        service => service.category === (currentCategory?.id || '')
    );

    useEffect(() => {
        // Ensure Bootstrap's global object (window.bootstrap) is available.
        // This assumes Bootstrap's JS is loaded globally, e.g., via a <script> tag in your public/index.html
        if (typeof window.bootstrap !== 'undefined' && window.bootstrap.Carousel) {
            // Select all carousel elements within this component's scope
            const carouselElements = document.querySelectorAll('.itinerary-gallery-carousel-instance');

            carouselElements.forEach(carouselEl => {
                // Get existing instance if any
                let carouselInstance = window.bootstrap.Carousel.getInstance(carouselEl);
                if (!carouselInstance) {
                    // Initialize a new carousel instance
                    // console.log('Initializing new carousel:', carouselEl.id);
                    carouselInstance = new window.bootstrap.Carousel(carouselEl);
                } else {
                    // If you need to re-initialize or update options on an existing one:
                    // For example, if items change, you might need to go to the first slide.
                    // carouselInstance.to(0);
                    // carouselInstance.cycle(); // Or restart cycling if needed
                }
            });

            // Optional: Cleanup on component unmount (or when servicesForCurrentCategory changes before next effect)
            // return () => {
            //     carouselElements.forEach(carouselEl => {
            //         const instance = window.bootstrap.Carousel.getInstance(carouselEl);
            //         if (instance) {
            //             instance.dispose();
            //         }
            //     });
            // };
        }
    }, [servicesForCurrentCategory]); // Re-run this effect if the services (and thus carousels) change

    return (
        <DashboardLayout activeMenuItem="Mis Rutas" isScrollable={true}>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3">
                <div className="d-flex align-items-center">
                    <Link to={`/itinerary/${itineraryId}`} className="btn btn-back-circle me-3" title="Volver al itinerario">
                        <i className="bi bi-arrow-left"></i>
                    </Link>
                    <h1 className="h2 mb-0">Galería completa</h1>
                </div>
            </div>

            <div className="row mb-5">
                {galleryData.categories.map(category => (
                    <InfoCard
                        key={category.id}
                        imageUrl={category.image}
                        imageAlt={category.title}
                        title={category.title}
                        colClasses="col-md-3 mb-3" // Default, but explicit for clarity
                        cardClasses="card card-service border-0" // Default, but explicit
                    />
                ))}
            </div>

            {currentCategory && (
                <>
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2">
                        <h2 className="h2 mb-4">{currentCategory.title}</h2>
                    </div>

                    {servicesForCurrentCategory.map(service => (
                        <div className="row text-start mb-4" key={service.id}>
                            <div className="col-12">
                                <div className="card card-metric border-0">
                                    <div className="card-body px-md-2 px-0">
                                        <h3 className="mb-4 text-start">{service.title}</h3>
                                        <div className="carousel-wrapper">
                                            <div id={`carousel-${service.id}`} className="carousel slide itinerary-gallery-carousel-instance" data-bs-ride="carousel"> {/* Added a common class for easier selection */}
                                                <div className="carousel-indicators">
                                                    {service.images.map((_, index) => (
                                                        <button
                                                            key={index}
                                                            type="button"
                                                            data-bs-target={`#carousel-${service.id}`}
                                                            data-bs-slide-to={index}
                                                            className={index === 0 ? 'active' : ''}
                                                            aria-current={index === 0 ? 'true' : 'false'}
                                                            aria-label={`Service Images Set ${index + 1}`}
                                                        ></button>
                                                    ))}
                                                </div>
                                                <div className="carousel-inner" style={{ borderRadius: '8px' }}>
                                                    {service.images.map((imageGroup, groupIndex) => (
                                                        <div className={`carousel-item ${groupIndex === 0 ? 'active' : ''}`} key={groupIndex}>
                                                            <div className="row">
                                                                {imageGroup.map((imgSrc, imgIndex) => (
                                                                    <div className="col-md-4" key={imgIndex}>
                                                                        <img src={imgSrc} className="d-block w-100" alt={`Service ${service.title} Image ${groupIndex * 3 + imgIndex + 1}`} />
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                                <button className="carousel-control-prev" type="button" data-bs-target={`#carousel-${service.id}`} data-bs-slide="prev">
                                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button className="carousel-control-next" type="button" data-bs-target={`#carousel-${service.id}`} data-bs-slide="next">
                                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </>
            )}
        </DashboardLayout>
    );
};

export default ItineraryGalleryUserScreen;